import React from "react"
import { useDispatch, useSelector } from "react-redux"

import DemographicChips from "../../../components/shared/demographicFilter/demographicChips"
import { removeFilter } from "../store/rankings.actions"
import { getFiltersAsChips } from "../store/rankings.selectors"
import { TableWrapper } from "../styles"

const AwardsChips = () => {
  const dispatch = useDispatch()
  const chipFilters = useSelector(getFiltersAsChips)

  const handleRemove = (value, label, key) => {
    dispatch(removeFilter({ value, label, key }))
  }

  return (
    <TableWrapper flexWrap="wrap">
      <DemographicChips demographicsFilter={chipFilters} onRemoveFilterItem={handleRemove} />
    </TableWrapper>
  )
}

export default AwardsChips
